import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { Button, InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import { DialogConfirmation } from "../../../components/common/Converter";
import ScheduleReportPagePresenter from "./ScheduleReportPagePresenter";
import SearchSelect from "../../../components/searchSelect/SearchSelect";
import Progress from "../../../components/Progress";
import Hierarchy from "../../../components/common/Hierarchy";

class ScheduleReportPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ScheduleReportPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      objects: [],
      count: 0,
      limit: 50,
      current: 1,
      selectedSchedule: {},
      scheduleTemplate: [],
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const isScheduler = this.getCurrentRoles()?.some(
      (item) => item.id === "Scheduler",
    );
    this.setState({ isScheduler });
    console.log("IS: ", isScheduler);
  }

  getCollectionName() {
    return "employees";
  }

  async handleDeleteData(id) {
    DialogConfirmation(id, this.getCollectionName(), () => this.refetchData());
  }

  // edit function
  async handleEditData(id) {
    this.navigateTo(`/collection/${this.getCollectionName()}/form/${id}`);
    // this.refetchData();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleOnChange(field, value) {
    this.setState({ [field]: value });
    const formatter = { [field]: { id: value.id } };
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          ...formatter,
        },
      }),
      () => {
        this.filterSubmit(this.state.filters);
      },
    );
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    // console.log("schema: ", schema);
    const { objects, loading, current, count, limit } = this.state;

    const exclude = Object.keys(schema.fields).filter(
      (key) => !this.presenter?.keys?.includes(key),
    );
    if (!schema) return <Progress />;
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Reference Table {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="row">
                  <SearchSelect
                    focus={true}
                    value={this.state.selectedSchedule?.name}
                    onChange={(value) =>
                      this.handleOnChange("selectedSchedule", value)
                    }
                    onClickClear={() =>
                      this.handleOnChange("selectedSchedule", "")
                    }
                    options={this.state.scheduleTemplate.map((schedule) => ({
                      label: schedule.name,
                      value: {
                        name: schedule.name,
                        id: schedule.id,
                      },
                    }))}
                  />
                  {!this.state.isScheduler && (
                    <Hierarchy
                      className="col-lg-6 p-2"
                      required={false}
                      // object={object}
                      handleObjectChange={(hierarchy) =>
                        this.presenter.handleHierarchyChange(hierarchy)
                      }
                    />
                  )}
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button
                        onClick={() =>
                          this.presenter.exportToCSV(
                            this.state.selectedSchedule,
                            schema,
                          )
                        }
                        disabled={
                          Object.keys(this.state.selectedSchedule).length === 0
                        }
                      >
                        Export CSV
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                objectId={this.handleDeleteData.bind(this)}
                editId={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                // actionsList={[
                //   {
                //     label: <i className="bi bi-three-dots-vertical" />,
                //     actionType: "common",
                //   },
                // ]}
                excludeFields={Object.keys(schema.fields).reduce((acc, key) => {
                  const options = schema.fields[key];
                  if (options.read === false) {
                    acc.push(key);
                  }
                  switch (options._type || options.type) {
                    case "Relation":
                    case "Array":
                    case "Object":
                    case "File":
                      acc.push(key);
                      break;
                    default:
                  }
                  return acc;
                }, exclude)}
                // selected={selected}
                // onSelect={this.onSelect.bind(this)}
                // onSelectAll={this.onSelectAll.bind(this)}
                // progress={progress}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(ScheduleReportPage);
